import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ResetPassword } from '@jobcost-monorepo/ui';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();

  return <ResetPassword token={searchParams.get('token')} />;
};

export default ResetPasswordPage;
